// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"2ec977ec","107":"e850f7a2","144":"b91ae684","371":"e77b6dff","563":"ed12836b","590":"bc6148d0","597":"c7338da3"}[chunkId] + ".chunk.js";
};